import { isBrowser } from './env.js';
import { isFunction } from './is.js';

function throttle(fn, ctx) {
    let pending = false;
    let first = true;
    let args = null;
    return function () {
        args = arguments;
        if (first) {
            first = false;
            return fn.apply(ctx, args);
        }
        if (pending)
            return;
        pending = true;
        requestAnimationFrame(() => {
            fn.apply(ctx, args);
            pending = false;
        });
    };
}
function throttleTime(fn, time = 0, ctx) {
    let pending = false;
    let first = true;
    let args = null;
    return function () {
        args = arguments;
        if (first) {
            first = false;
            return fn.apply(ctx, args);
        }
        if (pending)
            return;
        pending = true;
        setTimeout(() => {
            fn.apply(ctx, args);
            pending = false;
        }, time);
    };
}
function getChangedAttrs(newV, oldV, updateOld = false) {
    const patch = [];
    Object.keys(newV).forEach((x) => {
        if (newV[x] !== oldV[x]) {
            patch.push([x, newV[x], oldV[x]]);
            if (updateOld)
                oldV[x] = newV[x];
        }
    });
    return patch;
}
const nextTick = isBrowser && 'queueMicrotask' in window && isFunction(queueMicrotask) ? queueMicrotask : (fn) => Promise.resolve().then(fn);

export { getChangedAttrs, nextTick, throttle, throttleTime };
